import { FIELD_TYPES } from "constants/template-field-type";
import { AUTO, BEST, GOOD, ECO, LOW } from "constants/cloudinary-asset-qualities";
export default {
    assetQuality: {
        type: FIELD_TYPES.COMBO,
        label: "Asset Quality",
        options: [
            {
                value: AUTO,
                text: "Auto"
            },
            {
                value: BEST,
                text: "Best"
            },
            {
                value: GOOD,
                text: "Good"
            },
            {
                value: ECO,
                text: "Eco"
            },
            {
                value: LOW,
                text: "Low"
            }
        ]
    },
    useDynamicAsset: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Use dynamic asset (when available)"
    },
    useWindowMask: {
        type: FIELD_TYPES.BOOLEAN,
        label: "Use window mask"
    },
    minHeight: {
        type: FIELD_TYPES.TEXT,
        label: "Min height"
    }
};
